import React from "react";
import ProgressiveImage from "react-progressive-image-loading"
import {withTranslate} from "react-redux-multilingual"

const IntroSlide = ({translate, slide}) => {
    const cacheOffer = (e) => {
        e.preventDefault();
        if (slide.type === 0) {
            window.localStorage.removeItem("offer");
            window.localStorage.setItem("offer", JSON.stringify(slide.offer));
        }
        window.location.href = "/doctor/" + (slide.type === 0 ? slide.offer.doctor.unique_id : slide.doctor.unique_id);
    };

    return (
        <div className="intro-bg">
            {/*<div className="gradient" id="gradient"></div>*/}
            <div className="bg-overlay"></div>
            <div className="intro-image image-responsive">
                <ProgressiveImage
                    preview="./../../images/intro-slide-placeholder.png"
                    src={slide.background}
                    render={(src, style) => <img alt="head" src={src} style={style}/>}/>
            </div>
            <div className="hgroup">

                {/*<h1 className="title white bolder capitalized">{slide.title}</h1>
                <p className="subtitle bolder capitalized">{slide.desc}</p>*/}

            </div>
            <div className="device" id="device" style={{background: "url(" + slide.screen_shot + ") 0 0 / cover no-repeat"}}>
                <div className="device-overlay">
                    <a href="/" onClick={(e) => cacheOffer(e)}>
                        <button className="bolder">
                            {translate("search_for_doctors")}
                        </button>
                    </a>
                </div>
            </div>

            <div className="btn-ad-mobile hidden-md hidden-lg">
                <a href="/" onClick={(e) => cacheOffer(e)} className="bolder">
                    {translate("search_for_doctors")}
                </a>
            </div>



        </div>
    )
}
export default withTranslate(IntroSlide)